"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SvgWindDirectionIcon = (0, react_1.forwardRef)((props, ref) => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 21 25', ref: ref }, props, { children: (0, jsx_runtime_1.jsx)("path", { fill: 'currentColor', fillRule: 'nonzero', d: 'M9.264.523a1.727 1.727 0 0 1 2.476 0l8.747 8.93c.503.513.65 1.277.378 1.947a1.75 1.75 0 0 1-1.619 1.105h-5.248v10.263C13.998 24 13.02 25 11.811 25H9.187c-1.208 0-2.186-.999-2.186-2.232V12.499H1.752a1.76 1.76 0 0 1-1.618-1.105 1.82 1.82 0 0 1 .377-1.947L9.258.517z' }) })));
});
exports.default = (0, react_1.memo)(SvgWindDirectionIcon);
